import React from 'react';
import { TESTIMONIALS } from '../utils/constants';
import { StarIcon } from 'lucide-react';
export const TestimonialsSection: React.FC = () => {
  return <section className="py-20 px-4 bg-gray-50" data-id="element-272">
      <div className="container mx-auto max-w-6xl" data-id="element-273">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16" data-id="element-274">
          Lo que dicen los profesores que ya lo probaron
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-275">
          {TESTIMONIALS.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-md border border-gray-100 flex flex-col h-full" data-id="element-276">
              <div className="flex gap-1 mb-6" data-id="element-277">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-278" />)}
              </div>

              <p className="text-gray-700 italic mb-8 flex-grow text-lg leading-relaxed" data-id="element-279">
                "{testimonial.text}"
              </p>

              <div className="border-t border-gray-100 pt-6" data-id="element-280">
                <p className="font-bold text-gray-900" data-id="element-281">{testimonial.name}</p>
                <p className="text-sm text-gray-500" data-id="element-282">
                  {testimonial.age} años • {testimonial.city}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};